@if (!isLoading) {
  <div class="{{ className }}">
    <div class="{{ className }}__wrapper">
      <h2 class="{{ className }}__title">Choose your company</h2>

      <ul class="{{ className }}__list scroll-multicompany" id="scrollTabs">
        @for (company of allCompanies; track $index) {
          <li class="{{ className }}__item">
            <button
              (click)="selectCompany(company.id, company.name)"
              class="{{ className }}__button"
            >
              <div class="{{ className }}__avatar">
                <img
                  class="{{ className }}__avatar-img"
                  [ngSrc]="company.avatar"
                  [alt]="company.name"
                  priority
                  width="81"
                  height="81"
                />
                <mat-icon class="{{ className }}__icon"> open_in_new</mat-icon>
              </div>
              <span
                class="{{ className }}__name"
                matTooltip="{{ company.name }}"
                matTooltipClass="custom-tooltip"
                matTooltipPosition="below"
              >
                {{ company.name }}
              </span>
            </button>
          </li>
        }
      </ul>
    </div>
  </div>
}